import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import React, { useContext, useMemo } from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import ContactContext from 'contexts/contactContext'
import getIsLoyaltyPrioritySupportNumberEnabled from 'loyalty/selectors/getIsLoyaltyPrioritySupportNumberEnabled'
import { useAppSelector } from 'hooks/reduxHooks'

const image: App.Image = {
  id: 'kf3r6fahlubu2yb1htkgb',
  title: 'Faster, priority support',
}

interface Props {
  tier: App.LoyaltyTier
}

function LandingPageLoyaltyPhoneSupport(props: Props) {
  const { tier } = props
  const contact = useContext(ContactContext)
  const isLoyaltyPrioritySupportNumberEnabled = useAppSelector(getIsLoyaltyPrioritySupportNumberEnabled)
  const benefitAction = useMemo(() => {
    if (!isLoyaltyPrioritySupportNumberEnabled) return
    return <TextButton kind="secondary" href={`tel:${contact.local.number}`} startIcon={<LinePhoneIcon />}>
      {contact.local.humanReadable}
    </TextButton>
  }, [isLoyaltyPrioritySupportNumberEnabled, contact.local.number, contact.local.humanReadable])

  return <LandingPageLoyaltyBenefitTile
    heading="Faster, priority support"
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>All year round</LoyaltyTierLabel>}
    image={image}
    actions={benefitAction}
  >
    <BodyText variant="medium">
      Skip the queue. Our dedicated support team is just a call away, any time of day or night, with faster response times and help when you need it most.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyPhoneSupport
